import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminClients_id = z.any()
export type TagsGetAdminClients_id = z.infer<typeof tagsGetAdminClients_id>

export const paramsGetAdminClients_id = z.object({ "id": z.string() })
export type ParamsGetAdminClients_id = z.infer<typeof paramsGetAdminClients_id>

export const responseGetAdminClients_id = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "email": z.string().email(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "municipalityCount": z.number(), "privileges": z.array(z.string()), "municipality": z.object({ "id": z.string(), "name": z.string(), "ico": z.string(), "parseLimit": z.number().optional() }).optional(), "municipalities": z.array(z.object({ "id": z.string(), "name": z.string(), "ico": z.string(), "parseLimit": z.number().optional() })).optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminClients_id = z.infer<typeof responseGetAdminClients_id>

interface IGetAdminClients_id extends BaseMethodType {
  tags: TagsGetAdminClients_id,
  params: ParamsGetAdminClients_id,
  response: ResponseGetAdminClients_id
}
export const tagsPatchAdminClients_id = z.any()
export type TagsPatchAdminClients_id = z.infer<typeof tagsPatchAdminClients_id>

export const paramsPatchAdminClients_id = z.object({ "id": z.string() })
export type ParamsPatchAdminClients_id = z.infer<typeof paramsPatchAdminClients_id>

export const bodyPatchAdminClients_id = z.object({ "municipality": z.object({ "id": z.string().optional(), "name": z.string().optional(), "ico": z.string().optional() }).optional(), "user": z.object({ "name": z.string().optional(), "email": z.string().email().optional(), "verifiedEmail": z.boolean().optional(), "verifiedByAdmin": z.boolean().optional() }).optional(), "privileges": z.array(z.string()).optional() })
export type BodyPatchAdminClients_id = z.infer<typeof bodyPatchAdminClients_id>

export const responsePatchAdminClients_id = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "email": z.string().email(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "municipalityCount": z.number(), "privileges": z.array(z.string()), "municipality": z.object({ "id": z.string(), "name": z.string(), "ico": z.string(), "parseLimit": z.number().optional() }).optional(), "municipalities": z.array(z.object({ "id": z.string(), "name": z.string(), "ico": z.string(), "parseLimit": z.number().optional() })).optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchAdminClients_id = z.infer<typeof responsePatchAdminClients_id>

interface IPatchAdminClients_id extends BaseMethodType {
  tags: TagsPatchAdminClients_id,
  params: ParamsPatchAdminClients_id,
  body: BodyPatchAdminClients_id,
  response: ResponsePatchAdminClients_id
}
export const URL = '/admin/clients/:id'
export const validation = {
  get: {
    tags: tagsGetAdminClients_id,
    params: paramsGetAdminClients_id,
    response: responseGetAdminClients_id
  },
  patch: {
    tags: tagsPatchAdminClients_id,
    params: paramsPatchAdminClients_id,
    body: bodyPatchAdminClients_id,
    response: responsePatchAdminClients_id
  }
}
export interface AdminClients_id extends BaseRouteType {
  get: IGetAdminClients_id,
  patch: IPatchAdminClients_id
}